import React from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';
import { SecurityAlertSystem } from '@/components/security/SecurityAlertSystem';
import { useAuth } from '@/context/AuthContext';

function AppContent({ children }: { children: React.ReactNode }) {
  const { user, isAdmin } = useAuth();
  
  // Apply session timeout
  useSessionTimeout({
    timeoutMinutes: isAdmin ? 15 : 30, // Shorter timeout for admins
    warningMinutes: 5,
    extendOnActivity: true
  });

  return (
    <>
      {children}
      <SecurityAlertSystem />
    </>
  );
}

export function AppWithSecurity({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <AppContent>
        {children}
      </AppContent>
    </AuthProvider>
  );
}